module.exports = __webpack_public_path__ + "static/media/courier-white.90d28726.svg";